import { createContext } from 'react';

/**
 * Depth of a modal within `useModalStack`'s stack (0 = first pushed). Consumed
 * by the shared Modal shell to give each stacked modal-backdrop a distinct,
 * increasing z-index instead of relying on DOM paint order to keep the
 * topmost pushed modal above lower ones (#6042, #6053).
 */
export const ModalStackDepthContext = createContext(0);
